module.exports = __webpack_public_path__ + "img/qurban.3095eb59.svg";